/**
 * MiniMiser.WebApi
 * A web API for client access to patient records.   Build date: 2/19/2019 6:49:21 PM
 *
 * OpenAPI spec version: v1.0.02.19
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface PatientModel {
    /**
     * ID of the inquiry information
     */
    inquiryID?: number;
    patientID?: number;
    firstName?: string;
    lastName?: string;
    preferredName?: string;
    birthdate?: Date;
    relationshipToPatient?: string;
    isSelf?: boolean;
    isFullyResponsibleForPatient?: boolean;
    canViewIntake?: boolean;
    canManageIntake?: boolean;
    canViewSchedule?: boolean;
    canManageSchedule?: boolean;
    canViewDocuments?: boolean;
    canManageDocuments?: boolean;
    canViewStatement?: boolean;
    canSignForPatient?: boolean;
    canViewSendMessages?: boolean;
    financialResponsibilityRatio?: number;
    /**
     * This is a new client. They can edit all fields
     */
    isNewClient?: boolean;
    isOnWaitList?: boolean;
    hasActiveAuthorization?: boolean;
    hasMedClinicAuthorization?: boolean;
    hasPsychMedAuthorization?: boolean;
    inactive?: boolean;
    signedDate?: Date;
    signatureRequestPending?: boolean;
    insurancesReviewPending?: boolean;
    hasAllRequiredDocsSigned?: boolean;

    hasOptumMedicaid: boolean;

    formsNotSigned?: number;
    requiredFormsNotSigned?: number;
    hasValidPayorCoverage?: boolean;
}
